import { StyleSheet } from 'react-native';

import { Colors } from '../Themes';

export default StyleSheet.create({
  icon: {
    alignSelf: 'center',
  },
  cardStyle: theme => ({
    alignSelf: 'center',
    width: '90%',
    marginTop: 15,
    borderRadius: 6,
    marginHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    shadowColor: Colors.linegrey,
    shadowOffset: { height: 2, width: 0 },
    shadowRadius: 8,
    shadowOpacity: 1,
    elevation: 11,
    paddingVertical: 26,
  }),
  text: theme => ({
    fontSize: 16,
    color: theme.colors.headerColor,
    alignSelf: 'center',
    marginTop: 16,
  }),
  tryButton: {
    alignSelf: 'center',
    marginTop: 16,
    flexDirection: 'row',
  },
  txtButton: theme => ({
    color: theme.isDark ? Colors.fresh_orange : Colors.vfRed,
    fontSize: 16,
  }),
  iconButton: {
    marginLeft: 10,
    marginTop: -2,
    alignItems: 'center',
  },
});
